import React, { useState, useEffect } from "react"
import { Button, Col, Row } from "react-bootstrap"
import {
  doc,
  deleteDoc,
  collection,
  getDocs,
  query,
  updateDoc,
} from "firebase/firestore"
import { db } from "../../Firebase/config"
import Notify from "../Componentslogic/Usenotifications"
import Modal from "react-bootstrap/Modal"
export const AdminMobilemenucard = ({ products, onEdit, onDelete }) => {
  const [show, setShow] = useState(false)
  const [purchaseCount, setPurchaseCount] = useState(0)
  const [available, setAvailable] = useState(products.available ?? true)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  useEffect(() => {
    const fetchPurchaseCount = async () => {
      try {
        const q = query(collection(db, "Orders"))
        const querySnapshot = await getDocs(q)

        let totalCount = 0
        querySnapshot.forEach((orderDoc) => {
          const cartItems = orderDoc.data().cartItems || []
          cartItems.forEach((item) => {
            if (item.name === products.name) {
              totalCount += item.CartTotalQuantity || 0 // Sum quantities for the matching product
            }
          })
        })

        setPurchaseCount(totalCount) // Update the state with the total count
      } catch (error) {
        console.error("Error fetching purchase count:", error)
      }
    }

    fetchPurchaseCount()
  }, [products.name])

  // Function to handle marking product as available/unavailable
  const handleToggleAvailability = async () => {
    try {
      const productRef = doc(db, "Products", products.id)
      await updateDoc(productRef, { available: !available }) // Toggle availability

      setAvailable(!available) // Update state immediately
      Notify(
        `Product marked as ${!available ? "Available" : "Unavailable"}`,
        "success"
      )
    } catch (error) {
      console.error("Error updating availability")
      Notify("Failed to update product status", "error")
    }
  }

  const handleDelete = async () => {
    try {
      await deleteDoc(doc(db, "Products", products.id))
      Notify("Product deleted", "success")
      onDelete(products.id) // Call the parent handler to update local state
      setShow(false)
    } catch (error) {
      console.error("Error deleting product:", error)
    }
  }

  return (
    <div className="mobile-order-card">
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Confirm Delete </Modal.Title>
        </Modal.Header>
        <Modal.Body>are you sure you want to delete {products.name}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <h3 className="Product-title">{products.name}</h3>
      <span>
        Purchased: <b>{purchaseCount}</b> times
      </span>
      <p>
        <strong>{products.categoryName || ""}</strong>
      </p>
      <p className="mb-3">{products.description}</p>
      <h4>
        Price: {products.Price ? products.Price : products.sizes[0].Price} EGP
      </h4>

      <div className="mobile-user-actions">
        <button className="mobile-action-btn p-3 " onClick={onEdit}>
          Edit
        </button>
        <button
          className={`mobile-action-btn p-3 ${
            available ? "available" : "unavailable"
          }`}
          onClick={() => setAvailable(!available)}
        >
          {available ? "Available" : "Unavailable"}
        </button>
      </div>

      <div className="d-flex justify-content-end mt-3">
        <img
          onClick={() => setShow(true)}
          className="nxtimg"
          src="delete.png"
          alt="delete icon"
        />
      </div>
    </div>
  )
}
